import React from "react"
import * as AppConstants from "../../utility/AppConstants"
import { Messages } from "@sogei/react-web-components-catalog"
function InfoRiservatezza() {
    return (
        <React.Fragment>
            <Messages
                successMessages={[]}
                infoMessages={[
                    {
                        text: `Per motivi di riservatezza, non vengono visualizzate nelle tabelle le frequenze (minori o pari a 3)
                che potrebbero potenzialmente consentire l’indiretta identificazione di posizioni soggettive.
                In tal caso, i dati sono oscurati e sostituiti dai seguenti caratteri "${AppConstants.CARATTERE_RISERVATEZZA}"`
                    }
                ]}
                warningMessages={[]}
                dangerMessages={[]}
            ></Messages>
        </React.Fragment>
    )
}

export default InfoRiservatezza
